"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var overview_field_type_1 = require("../model/overview-field-type");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var custom_aggregate_functions_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var overview_custom_component_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-component/overview-custom-component-provider.service");
var portfolio_definition_custom_values_service_1 = require("../../../../shared/services/api/portfolio-definition-custom-values.service");
/**
 * Initiates overview field's additional properties
 */
var OverviewInitFieldPropertiesPipe = /** @class */ (function () {
    function OverviewInitFieldPropertiesPipe(customAggregateFunctionsProviderService, overviewCustomComponentProviderService, portfolioDefinitionCustomValuesService, kbService) {
        this.customAggregateFunctionsProviderService = customAggregateFunctionsProviderService;
        this.overviewCustomComponentProviderService = overviewCustomComponentProviderService;
        this.portfolioDefinitionCustomValuesService = portfolioDefinitionCustomValuesService;
        this.kbService = kbService;
    }
    OverviewInitFieldPropertiesPipe.prototype.transform = function (overviewField, category, rootCategory, isPortfolioField) {
        var _this = this;
        var loadFields$ = category ? this.kbService.getMetaFields(category) : Observable_1.Observable.of([]);
        return loadFields$.pipe(operators_1.switchMap(function (metaFields) {
            var returnedObject = {
                overviewField: overviewField,
                metaField: metaFields.find(function (field) { return field.getSystemName() === overviewField.fieldName; }),
                additionalMessages: {},
                additionalMetaFields: {}
            };
            var additionalMetaFields = returnedObject.additionalMetaFields;
            var additionalMessages = returnedObject.additionalMessages;
            if (overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE) {
                var setGroupingFieldAggregateParams$ = void 0;
                if (overviewField.aggregateConfig.sourceField) {
                    returnedObject.additionalMetaFields.sourceMetaField = metaFields.find(function (field) {
                        return field.getSystemName() === overviewField.aggregateConfig.sourceField;
                    });
                    setGroupingFieldAggregateParams$ =
                        _this.kbService.getMetaFields(returnedObject.additionalMetaFields.sourceMetaField.getCompoundCategorySystemName());
                }
                else {
                    setGroupingFieldAggregateParams$ = Observable_1.Observable.of(metaFields);
                }
                setGroupingFieldAggregateParams$ = setGroupingFieldAggregateParams$
                    .pipe(operators_1.tap(function (fields) {
                    additionalMetaFields.groupingMetaField = fields.find(function (field) {
                        return field.getSystemName() === overviewField.aggregateConfig.groupingField;
                    });
                    additionalMetaFields.aggregateParamMetaField = fields.find(function (field) {
                        return field.getSystemName() === overviewField.aggregateConfig.aggregateField;
                    });
                }));
                var setAggregateFunction$ = _this.customAggregateFunctionsProviderService
                    .getCustomAggregateFunctions(category, rootCategory).pipe(operators_1.tap(function (aggregateFunctions) {
                    var aggregateFunction = aggregateFunctions.find(function (func) { return func.key === overviewField.aggregateConfig.aggregateFunction; });
                    additionalMessages.aggregateFunctionMessage = aggregateFunction && aggregateFunction.title;
                }));
                return Observable_1.Observable.zip(setGroupingFieldAggregateParams$, setAggregateFunction$).pipe(operators_1.map(function () { return returnedObject; }));
            }
            if (overviewField.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT) {
                var customComponents$ = isPortfolioField ?
                    (_this.portfolioDefinitionCustomValuesService
                        ? _this.portfolioDefinitionCustomValuesService.getCustomComponents(category, rootCategory) : Observable_1.Observable.of([]))
                    : (_this.overviewCustomComponentProviderService
                        ? _this.overviewCustomComponentProviderService.getCustomComponents(category, rootCategory, null) : Observable_1.Observable.of([]));
                return customComponents$.pipe(operators_1.map(function (components) {
                    returnedObject.customComponent = components
                        .find(function (cmp) { return cmp.componentSelector === returnedObject.overviewField.fieldName; });
                    return returnedObject;
                }));
            }
            return Observable_1.Observable.of(returnedObject);
        }));
    };
    OverviewInitFieldPropertiesPipe = __decorate([
        core_1.Pipe({
            name: 'overviewInitFieldProperties',
            pure: true
        }),
        __param(1, core_1.Optional()),
        __param(2, core_1.Optional()),
        __metadata("design:paramtypes", [custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService,
            overview_custom_component_provider_service_1.OverviewCustomComponentProviderService,
            portfolio_definition_custom_values_service_1.PortfolioDefinitionCustomValuesService,
            idm_kb_service_client_js_1.KbService])
    ], OverviewInitFieldPropertiesPipe);
    return OverviewInitFieldPropertiesPipe;
}());
exports.OverviewInitFieldPropertiesPipe = OverviewInitFieldPropertiesPipe;
//# sourceMappingURL=overview-init-field-properties.pipe.js.map